export const ProcessingProblemsDialogDialogInitialState = {
  open: false,
  dialogTitle: undefined,
  description: undefined,
  messages: undefined,
  onBack: () => undefined,
  onContinue: () => undefined,
};
